import { instanceApi } from './api'

export const getAssinaturaPorModalidade = modalidadeParaAssinatura => {
  return instanceApi.get( `v1/assinatura/?modalidade=${modalidadeParaAssinatura}` )
}
